<template>
    <div class="scroll-container">
        <!-- 第一行：向左滚动 -->
        <div class="scroll-row scroll-left">
            <div class="scroll-content" :style="{ animationDuration: `${scrollSpeed}s` }">
                <div 
                    class="scroll-item" 
                    v-for="(item, index) in [...images_one, ...images_one]" 
                    :key="`left-${index}`"
                >
                    <img :src="item.img" alt="合作平台logo" class="image-placeholder" loading="lazy">
                </div>
            </div>
        </div>

        <!-- 第二行：向右滚动 -->
        <div class="scroll-row scroll-right">
            <div class="scroll-content" :style="{ animationDuration: `${scrollSpeed}s` }">
                <div 
                    class="scroll-item" 
                    v-for="(item, index) in [...images_tow, ...images_tow]"
                    :key="`right-${index}`"
                >
                    <img :src="item.img" alt="合作平台logo" class="image-placeholder" loading="lazy">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import img1 from "@/assets/images/logo/ba.png"
import img2 from "@/assets/images/logo/bitget@1x.png"
import img3 from "@/assets/images/logo/bybit@1x.png"
import img4 from "@/assets/images/logo/OKX@1x.png"
import img5 from "@/assets/images/logo/coinbase@1x.png"
import img6 from "@/assets/images/logo/exness@1x.png"
import img7 from "@/assets/images/logo/huobi@1x.png"
import img8 from "@/assets/images/logo/mexc@1x.png"
import img9 from "@/assets/images/logo/XM@1x.png"

export default {
    name: 'TwoWayScrollImages',
    data() {
        return {
            scrollSpeed: 25,
            images_one: [
                { img: img1 },
                { img: img2 },
                { img: img3 },
                { img: img4 },
            ],
            images_tow: [
                { img: img5 },
                { img: img6 },
                { img: img7 },
                { img: img8 },
                { img: img9 },
            ],
            resizeHandler: null // 存储resize回调引用，用于后续清除
        }
    },
    mounted() {
        // 1. 定义resize回调函数（单独提取，方便绑定/解绑）
        this.resizeHandler = () => {
            const scrollContents = document.querySelectorAll('.scroll-content');
            scrollContents.forEach(el => {
                // 关键：先记录当前动画进度，避免重绘后跳变
                const computedStyle = window.getComputedStyle(el);
                const matrix = new DOMMatrix(computedStyle.transform);
                const currentX = matrix.e; // 获取当前 translateX 数值

                // 重置动画（先停止，再触发重绘）
                el.style.animation = 'none';
                el.style.transform = `translateX(${currentX}px)`; // 保持当前位置
                void el.offsetWidth; // 强制触发DOM重绘

                // 重新启动动画（继承原滚动方向和速度）
                const animationName = el.parentElement.classList.contains('scroll-left') 
                    ? 'scrollLeft' 
                    : 'scrollRight';
                el.style.animation = `${animationName} ${this.scrollSpeed}s linear infinite`;
            });
        };

        // 2. 绑定resize事件（使用passive优化性能，避免滚动卡顿）
        window.addEventListener('resize', this.resizeHandler, { passive: true });
    },
    beforeUnmount() {
        // 3. 精准清除resize监听（必须传入和绑定相同的回调函数）
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler, { passive: true });
            this.resizeHandler = null; // 释放引用，避免内存泄漏
        }
    }
}
</script>

<style lang="scss" scoped>
.scroll-container {
    width: 100%;
    overflow: hidden;
    padding: 2vw 0;
    box-sizing: border-box;
}

.scroll-row {
    width: 100%;
    overflow: hidden;
    margin-bottom: 2vw;

    .scroll-content {
        display: flex;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        will-change: transform;
        transition: none; // 禁用过渡，避免重绘时闪烁
    }

    .scroll-item {
        width: 18vw;
        padding: 0 8px;
        box-sizing: border-box;
        flex-shrink: 0;
        min-width: 150px;

        .image-placeholder {
            width: 100%;
            height: 10vw;
            min-height: 80px;
            object-fit: contain;
            border-radius: 8px;
            background: linear-gradient(135deg, #1E242B 0%, #1A1D26 100%);
            padding: 1vw;
            box-sizing: border-box;
            transition: transform 0.3s ease;

            &:hover {
                transform: scale(1.05);
                background: #313b46;
                // border: 1px solid #ffd200;
            }
        }
    }
}

/* 向左滚动动画 */
@keyframes scrollLeft {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

/* 向右滚动动画 */
@keyframes scrollRight {
    0% {
        transform: translateX(-50%);
    }
    100% {
        transform: translateX(0);
    }
}

/* 动画名称绑定 */
.scroll-left .scroll-content {
    animation-name: scrollLeft;
}
.scroll-right .scroll-content {
    animation-name: scrollRight;
}

/* 响应式：大屏幕适配 */
@media (min-width: 768px) {
    .scroll-item .image-placeholder {
        height: 4vw;
        min-height: 100px;
    }
}

@media (min-width: 1440px) {
    .scroll-container {
        padding: 28px 0;
    }
    .scroll-row {
        margin-bottom: 28px;
    }
    .scroll-item {
        width: 259px;
        padding: 0 7px;
    }
    .scroll-item .image-placeholder {
        height: 80px;
        border-radius: 14px;
        padding: 14px;
    }
}

/* 移动端优化 */
@media (max-width: 767px) {
    /* 修复原代码错误：data属性不能直接在样式中使用，通过内联样式绑定速度 */
    .scroll-row .scroll-content {
        animation-duration: 35s !important;
    }
}
</style>